module.exports = __webpack_public_path__ + "img/icon-grand.411e78b5.svg";